import { ValidatorRules } from '../../../utils/Validator/types';
import validateSSN from '../../internal/SocialSecurityNumberBrazil/validate';

export const pixValidationRules: ValidatorRules = {
    socialSecurityNumber: {
        validate: validateSSN,
        errorMessage: '',
        modes: ['blur']
    },
    default: {
        validate: value => !!value && value.length > 0,
        errorMessage: '',
        modes: ['blur']
    }
};
